import { render, staticRenderFns } from "./InvoiceMultipleForm.vue?vue&type=template&id=36485a4a&scoped=true&"
import script from "./InvoiceMultipleForm.vue?vue&type=script&lang=js&"
export * from "./InvoiceMultipleForm.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceMultipleForm.vue?vue&type=style&index=0&id=36485a4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36485a4a",
  null
  
)

export default component.exports